var map = {
	"./adminprofile/add": [
		1962,
		18
	],
	"./agentprofile/add": [
		1963,
		21
	],
	"./ai_assistant/add": [
		1964,
		24
	],
	"./api_key/add": [
		1965,
		27
	],
	"./canned_answer/add": [
		1966,
		32
	],
	"./chat_configuration/add": [
		1967,
		5
	],
	"./client/add": [
		1968,
		35
	],
	"./disposition/add": [
		1969,
		40
	],
	"./field/add": [
		1970,
		43
	],
	"./form/add": [
		1971,
		46
	],
	"./form_website/add": [
		1972,
		49
	],
	"./invoice_post/add": [
		1973,
		56
	],
	"./journey/add": [
		1974,
		59
	],
	"./journey_draft/add": [
		1975,
		62
	],
	"./journey_variable/add": [
		1976,
		66
	],
	"./list/add": [
		1977,
		69
	],
	"./list_file/add": [
		1978,
		72
	],
	"./mail_account/add": [
		1979,
		75
	],
	"./operational_hours/add": [
		1980,
		78
	],
	"./organization/add": [
		1981,
		81
	],
	"./pause/add": [
		1982,
		84
	],
	"./phonenumber_monthly_cost/add": [
		1983,
		87
	],
	"./phonenumber_monthly_cost_parent/add": [
		1984,
		90
	],
	"./phonenumber_purchase/add": [
		1985,
		94
	],
	"./phonenumber_setup_cost/add": [
		1986,
		97
	],
	"./phonenumber_setup_cost_parent/add": [
		1987,
		100
	],
	"./prepaid_credit/add": [
		1988,
		107
	],
	"./queue/add": [
		1989,
		110
	],
	"./signature/add": [
		1990,
		114
	],
	"./skill/add": [
		1991,
		117
	],
	"./sla_policy/add": [
		1992,
		120
	],
	"./sound/add": [
		1993,
		123
	],
	"./stats_alarm/add": [
		1994,
		126
	],
	"./stats_custom_metric/add": [
		1995,
		129
	],
	"./stats_report/add": [
		1996,
		132
	],
	"./stats_widget/add": [
		1997,
		135
	],
	"./superadmin_profile/add": [
		1998,
		138
	],
	"./tag/add": [
		1999,
		141
	],
	"./tariff/add": [
		2000,
		144
	],
	"./tariff_parent/add": [
		2001,
		147
	],
	"./team/add": [
		2002,
		150
	],
	"./text_message_source/add": [
		2003,
		12
	],
	"./time_interval/add": [
		2004,
		154
	],
	"./user/add": [
		2005,
		157
	],
	"./voice_asterisk/add": [
		2006,
		160
	],
	"./voice_asterisk_downgrade/add": [
		2007,
		163
	],
	"./voice_route/add": [
		2008,
		170
	],
	"./voice_shortcut/add": [
		2009,
		173
	],
	"./voice_trunk/add": [
		2010,
		176
	],
	"./voice_voicemail/add": [
		2011,
		179
	],
	"./wallboard/add": [
		2012,
		182
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1882;
module.exports = webpackAsyncContext;